import type { IntegrationActivityEvent } from 'src/api/generated';
import { IntegrationActivityEventType } from 'src/api/generated';
import type { PropertyPortalPublication } from 'src/api/generated';
import type { PropertySyncTimelineItem } from '../types/property-sync-events.type';

export const isSyncActivityEvent = (event: IntegrationActivityEvent): boolean =>
  event.type === IntegrationActivityEventType.SYNC_APPLIED ||
  event.type === IntegrationActivityEventType.SYNC_SKIPPED ||
  event.type === IntegrationActivityEventType.SYNC_FAILED ||
  event.type === IntegrationActivityEventType.SYNC_RECONCILIATION_APPLIED;

export const buildPropertySyncTimeline = (
  publications: PropertyPortalPublication[],
  events: IntegrationActivityEvent[]
): PropertySyncTimelineItem[] => {
  const operationByPublicationId = new Map(
    publications.map((publication) => [publication.id, publication.operation])
  );
  const externalSourceIdByPublicationId = new Map(
    publications.map((publication) => [
      publication.id,
      publication.externalListingId ?? null,
    ])
  );

  return events
    .filter(isSyncActivityEvent)
    .map((event) => ({
      createdAt: event.createdAt,
      event,
      externalSourceId:
        event.externalSourceId ??
        (event.propertyPortalPublicationId != null
          ? externalSourceIdByPublicationId.get(
              event.propertyPortalPublicationId
            ) ?? null
          : null),
      operation:
        event.propertyPortalPublicationId != null
          ? operationByPublicationId.get(event.propertyPortalPublicationId) ??
            null
          : null,
      publicationId: event.propertyPortalPublicationId ?? null,
    }))
    .sort((left, right) => right.createdAt.localeCompare(left.createdAt));
};
